// TO'LIQ TELEFON RAQAMINI OCHISH — abonent doirasiga bo'ysunadigan yo'l.
//
// =====================================================================
// ⛔ NEGA `/api/contacts/{id}/reveal` EMAS — O'LCHANGAN (2026-08-24)
// =====================================================================
// Umumiy kontakt reestrining ochish yo'li (`ContactController:166`)
// sherikka YOPIQ va bu huquq masalasi EMAS: u `contact.reveal` dan
// TASHQARI butun tenantni qamraydigan DOIRANI ham talab qiladi
// (`ContactServiceImpl.reveal:182` -> `TenantWideGuard.require`, u esa
// faqat `TENANT`/`GLOBAL` da rost). Sherikning doirasi `OWN` (agent)
// yoki `SUBTREE` (reseller), ya'ni `contact.reveal` `PartnerKind` ga
// qo'shilgan bo'lsa ham chaqiruv 403 qaytarardi.
//
// Shuning uchun `xsib-subscriber` da ABONENT doirasiga bo'ysunadigan
// alohida yo'l ochildi (egasi qarori, 2026-08-24):
//
//   POST /api/subscribers/{id}/contact/reveal
//     huquq : contact.reveal
//     doira : abonent doirasi — begona abonentga 404 (403 EMAS)
//     tana  : { reason }  ← MAJBURIY, bo'shda 400
//     javob : { phone, phoneAlt }
//
// ⚠️ SABAB MAJBURIY va u BEZAK EMAS: ochish auditga tushadi, sababsiz
// jurnal esa «kim ko'rdi» degan savolga javob beradi-yu, «nega ko'rdi»
// ga bermaydi. Panel bo'sh sabab bilan so'rov YUBORMAYDI —
// `ContactRevealControl` (admin) dagi ayni qaror: har urinish auditga
// tushadi, ya'ni aniq rad etiladigan so'rov ham iz qoldirardi.

import axios from 'axios'
import { z } from 'zod'
import { api } from './client'

/**
 * ⛔ UCHTA RAQAM VA ULAR BOSHQA-BOSHQA MAYDONLAR — ARALASHTIRILMAYDI.
 *
 * Bu javobning eng qimmat tuzog'i (o'lchandi 2026-08-24): `phone`
 * KONTAKTNIKI EMAS.
 *
 *   · `phone`           — `subscriber.subscriber.phone`, ABONENT
 *     yozuvidagi raqam va SMS aynan undan oqadi (ADR-031 §2);
 *   · `contactPhone`    — `platform.contact.phone`;
 *   · `contactPhoneAlt` — `platform.contact.phone_alt`.
 *
 * ⛔ ULAR BIR XIL BO'LISHI SHART EMAS va ko'pincha boshqacha. Kontakt
 * blokida `phone` ni ko'rsatish BOSHQA odamning raqamini chizish
 * bo'lardi — va bu JIMGINA bo'lardi: maydonlar `.nullish()`, ya'ni
 * `parse` yiqilmaydi, xato jurnalida hech narsa yo'q, ekranda esa
 * ishonarli ko'rinadigan noto'g'ri raqam turadi. Aynan shu nuqson
 * sinfi bu kod bazasida takrorlanib turadi.
 *
 * ⚠️ Qaysi maydon qayerga borishi `tests/guards.mjs` da QOTIRILGAN.
 */
const revealSchema = z.object({
  contactId: z.string().nullish(),
  phone: z.string().nullish(),
  contactPhone: z.string().nullish(),
  contactPhoneAlt: z.string().nullish(),
})

export interface ContactReveal {
  /**
   * Kontakt yozuvi bor-yo'qligini ajratadi.
   *
   * ⚠️ `null` — XATO EMAS: abonentda kontakt yozuvi umuman yo'q
   * bo'lishi mumkin, o'shanda `contactPhone` ham bo'sh keladi.
   */
  contactId: string | null
  /** ⛔ ABONENT yozuvining raqami — SMS MANBASI, kontaktniki EMAS */
  phone: string | null
  /** `platform.contact.phone` */
  contactPhone: string | null
  /** `platform.contact.phone_alt` */
  contactPhoneAlt: string | null
}

/** Sabab uzunligi — admin panelidagi `ContactRevealControl` bilan bir xil */
export const REVEAL_REASON_MAX = 200

/**
 * To'liq raqamlarni ochadi.
 *
 * ⛔ NATIJA KESHGA SAQLANMAYDI va bu ONGLI QAROR (`fetchMyBatchCodes`
 * bilan ayni sabab): `useQuery` javobni `queryClient` ga qo'yardi va u
 * sahifadan chiqilgandan keyin ham xotirada, DevTools'da ochiq
 * ko'rinadigan holda yashardi. Bu yerda qiymat chaqiruvchining LOKAL
 * holatiga tushadi va komponent yo'qolganda u bilan birga yo'qoladi.
 *
 * ⚠️ Shu sababdan qayta ochishda SO'ROV QAYTA ketadi — va bu ham
 * to'g'ri: har ko'rish auditda alohida yozuv bo'lishi kerak.
 */
export async function revealSubscriberContact(
  subscriberId: string,
  reason: string,
): Promise<ContactReveal> {
  const response = await api.post<unknown>(`/api/subscribers/${subscriberId}/contact/reveal`, {
    reason: reason.trim(),
  })
  const parsed = revealSchema.parse(response.data)
  return {
    contactId: parsed.contactId ?? null,
    phone: parsed.phone ?? null,
    contactPhone: parsed.contactPhone ?? null,
    contactPhoneAlt: parsed.contactPhoneAlt ?? null,
  }
}

/**
 * Endpoint hali yozilmaganmi.
 *
 * ⚠️ `404` bu yerda IKKI narsani anglatishi mumkin: mapping yozilmagan
 * yoki abonent sherikning doirasidan TASHQARIDA (server ataylab 404
 * beradi, 403 emas — «bunday abonent bor» degan ma'lumotni oshkor
 * qilmaslik uchun). Panel ikkalasini ham «ochib bo'lmadi» deb
 * ko'rsatadi: ikkovida ham to'g'ri xulq bir xil va sherik hech narsa
 * buzmagan.
 */
export function isRevealUnavailable(error: unknown): boolean {
  return axios.isAxiosError(error) && error.response?.status === 404
}
